import { COLOR_PURPURE } from '../colors';

// ===== Border-Radius
export const BORDER_RADIUS_XXXL = '190px';
export const BORDER_RADIUS_XXL = '24px';
export const BORDER_RADIUS_XL = '20px';
export const BORDER_RADIUS_L = '16px';
export const BORDER_RADIUS_M = '12px';
export const BORDER_RADIUS_S = '8px';

// ===== Transitions
export const TRANSITION_300 = 'all 0.3s ease-out';
export const TRANSITION_500 = 'all 0.5s ease-out';

// ===== Borders
export const BORDER_MAIN = `1px solid ${COLOR_PURPURE}`;
